import React from 'react';
import { Alert } from 'antd';
import { useAuthStore } from '../features/auth/store/authStore';

const LicenseWarningBanner: React.FC = () => {
  const licenseWarning = useAuthStore((s) => s.user?.licenseWarning);

  if (!licenseWarning) {
    return null;
  }

  return (
    <Alert
      type="warning"
      showIcon
      message="Your organization license has passed its end date. Please contact support to renew."
      style={{ marginBottom: 16 }}
    />
  );
};

export default LicenseWarningBanner;
